export default "__VITE_ASSET__Cn8c0V$P__"